import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IoChevronForward } from 'react-icons/io5';
import { useAuth } from '../../../context/AuthContext';
import { getReferralStats } from '../../../services/referralStatsService';

// ───── 스타일 ─────

const Card = styled.div`
  background: #F1F5FF;
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => theme.spacing.lg};
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text};
  margin: 0 0 4px;
`;

const Desc = styled.p`
  font-size: 13px;
  color: #9CA3AF;
  font-family: 'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif;
  font-weight: 500;
  letter-spacing: -0.2px;
  margin: 0;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-top: 16px;
`;

const StatCell = styled.div`
  background: #fff;
  border-radius: ${({ theme }) => theme.radius.md};
  padding: 8px 4px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StatLabelWrap = styled.div`
  height: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StatLabel = styled.p`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.colors.textSecondary};
  white-space: nowrap;
  line-height: 1.3;
  margin: 0;
`;

const StatSub = styled.span`
  font-size: 9px;
  color: ${({ theme }) => theme.colors.textLight};
  line-height: 1;
  white-space: nowrap;
`;

const StatValue = styled.p`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.primary};
  margin: 2px 0 0;
`;

const Divider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.border};
  margin: 20px -${({ theme }) => theme.spacing.lg};
  padding: 0;
`;

const LinkRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

const LinkText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text};
`;

const LinkArrow = styled.span`
  color: ${({ theme }) => theme.colors.textLight};
  display: flex;
  align-items: center;
`;

// ───── 컴포넌트 ─────

const DEFAULT_STATS = [
  { label: '발송', value: 0 },
  { label: '가입', value: 0 },
  { label: '만료예정', sub: '(6개월 이내)', value: 0 },
  { label: '만료', value: 0 },
];

const ManageReferralTab = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const [stats, setStats] = useState(DEFAULT_STATS);

  useEffect(() => {
    if (!userData?.uid) return;
    getReferralStats(userData.uid).then((s) => {
      setStats([
        { label: '발송', value: s.sent },
        { label: '가입', value: s.joined },
        { label: '만료예정', sub: '(6개월 이내)', value: s.expiring },
        { label: '만료', value: s.expired },
      ]);
    }).catch(() => {});
  }, [userData?.uid]);

  return (
    <Card>
      <Title>공인중개사 추천 현황</Title>
      <Desc>추천부터 가입 전환까지의 성과를 추적합니다.</Desc>

      <StatsGrid>
        {stats.map((s) => (
          <StatCell key={s.label}>
            <StatLabelWrap>
              <StatLabel>{s.label}</StatLabel>
              {s.sub && <StatSub>{s.sub}</StatSub>}
            </StatLabelWrap>
            <StatValue>{s.value}</StatValue>
          </StatCell>
        ))}
      </StatsGrid>

      <Divider />

      <LinkRow onClick={() => navigate('/realtor/manage/referral-members')}>
        <LinkText>추천 가입회원 조회</LinkText>
        <LinkArrow><IoChevronForward size={18} /></LinkArrow>
      </LinkRow>
    </Card>
  );
};

export default ManageReferralTab;
